import type { PostalAddress } from '@app/icare/db/schema/common'
import { withFieldGroup } from '@app/icare/form/useAppForm'
import { t } from '@lingui/core/macro'
import { InputList } from '@pkg/ui/drawer'
import { Divider, Space } from 'antd'
import { useId } from 'react'

const addressDefaults: PostalAddress = {
  streetAddress: null,
  zipCode: null,
  city: null,
}

export const AddressFieldGroup = withFieldGroup({
  defaultValues: addressDefaults,
  props: { readonly: false } as { readonly?: boolean },
  render: function Render({ group, readonly }) {
    const idPrefix = useId()
    return (
      <InputList
        items={[
          {
            label: <label htmlFor={`${idPrefix}-streetAddress`}>{t`Straße & Hausnummer`}</label>,
            children: (
              <group.AppField
                name="streetAddress"
                children={field => (
                  <field.Text
                    formItemProps={{ style: { marginBottom: 0 } }}
                    readonly={readonly}
                    placeholder={t`Musterweg 1a`}
                    id={`${idPrefix}-streetAddress`}
                  />
                )}
              />
            ),
          },
          {
            label: (
              <Space size="small" separator={<Divider vertical />}>
                <label htmlFor={`${idPrefix}-zipCode`}>{t`Postleitzahl`}</label>
                <label htmlFor={`${idPrefix}-city`}>{t`Ort`}</label>
              </Space>
            ),
            children: (
              <div className="grid grid-cols-[1fr_15px_1fr] gap-2 items-center">
                <group.AppField
                  name="zipCode"
                  children={field => (
                    <field.Text
                      formItemProps={{ style: { marginBottom: 0 } }}
                      readonly={readonly}
                      placeholder={t`12345`}
                      id={`${idPrefix}-zipCode`}
                    />
                  )}
                />
                <Divider vertical />
                <group.AppField
                  name="city"
                  children={field => (
                    <field.Text
                      formItemProps={{ style: { marginBottom: 0 } }}
                      readonly={readonly}
                      placeholder={t`Musterhausen`}
                      id={`${idPrefix}-city`}
                    />
                  )}
                />
              </div>
            ),
          },
        ]}
      />
    )
  },
})
